import { create } from 'zustand';

type TrackmanParametersSelectionStore = {
  selectedCategoryId: string | null;
  selectedSubcategoryId: string | null;
  selectedParameterId: string | null;
  selectCategory: (categoryId: string) => void;
  selectSubcategory: (subcategoryId: string) => void;
  selectParameter: (parameterId: string) => void;
};

export const useTrackmanParametersSelectionStore = create<TrackmanParametersSelectionStore>((set) => ({
  selectedCategoryId: null,
  selectedSubcategoryId: null,
  selectedParameterId: null,
  selectCategory: (categoryId) => set({ selectedCategoryId: categoryId, selectedSubcategoryId: null, selectedParameterId: null }),
  selectSubcategory: (subcategoryId) => set({ selectedSubcategoryId: subcategoryId, selectedParameterId: null }),
  selectParameter: (parameterId) => set({ selectedParameterId: parameterId }),
}));
